import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@authoxi/ui-shared/styles/tokens.css";
import "@authoxi/ui-shared/styles/base.css";
// The shared lead gate's structure. No colour of its own — every value is a var() on the
// tokens imported above, so it inherits this product's palette by being loaded after them.
import "@authoxi/ui-shared/leadgate.css";
import "./styles.css";
import App from "./App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
